var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 8.80704V3.5H7.43744C7.02323 3.5 6.68744 3.16421 6.68744 2.75C6.68744 2.33579 7.02323 2 7.43744 2H16.5624C16.9767 2 17.3124 2.33579 17.3124 2.75C17.3124 3.16421 16.9767 3.5 16.5624 3.5H15.9999V8.80704L21.125 18.1082C22.089 19.8576 20.8235 22 18.826 22H5.17391C3.17642 22 1.91084 19.8576 2.87484 18.1082L7.99994 8.80704ZM14.4999 3.5H9.49994V9C9.49994 9.12658 9.46791 9.25109 9.40682 9.36195L7.12667 13.5H16.8732L14.5931 9.36195C14.532 9.25109 14.4999 9.12658 14.4999 9V3.5ZM4.18859 18.8321L6.30014 15H17.6997L19.8113 18.8321C20.2244 19.5818 19.682 20.5 18.826 20.5H5.17391C4.31784 20.5 3.77545 19.5818 4.18859 18.8321Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/beaker.5a664651.svg";
export { ForwardRef as ReactComponent };